import * as React from "react";
import { observer } from "mobx-react";
import ActionDefinitionStore from "../stores/ActionDefinitionStore";
import ActionDefinitionForm from "./ActionDefinitionForm";
import AppModal from "../../common/components/AppModal";

type Props = {
    store: ActionDefinitionStore;
};

const ActionDefinitionCreateEditDialog: React.FC<Props> = ({ store }) => {
    const mode = store.editDialogMode;

    return (
        <AppModal
            data-id-type="modal-window"
            data-id-name="edit-action-definition"
            className="alpha-modal"
            title={
                <span className="dialog-title">
                    {mode === "create" ? "Create" : "Edit"} action definition
                </span>
            }
            open={store.editDialogVisible}
            closable={false}
            centered
            width={1110}
            cancelButtonTitle="Cancel"
            onCancelClick={() => {
                store.setNewDefinitionDialogVisible(false);
            }}
            cancelButtonProps={{
                "data-id": "button-edit-action-definition-cancel",
            }}
            submitButtonTitle={mode === "create" ? "Create" : "Save"}
            submitButtonProps={{
                "data-id": "button-edit-action-definition-save",
                className: "dark",
                form: "edit-action-definition-form",
            }}
        >
            <ActionDefinitionForm store={store} />
        </AppModal>
    );
};

export default observer(ActionDefinitionCreateEditDialog);
